import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import getValidators from './validators';

import {
  cloneDeep,
  includes,
  find,
  isArray,
  toArray,
  isEmpty,
  get,
  pull,
  set,
  isUndefined,
  isFunction,
  keys,
  forEach,
  defer,
  reject as rejectItem,
  values,
  without,
  flatten
} from 'lodash';

import {
  formFields,
  groupFields,
  schemaFields,
  formFieldsConstraints,
  schemaFieldsConstraints
} from './fieldTypes';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import AppBar from '@material-ui/core/AppBar';
import Input from '@material-ui/core/Input';

import dataFields from '../../ui/datafields';

const logError = () => {};
const ALL_AVAILABLE_VALIDATORS = getValidators();

class FieldDetailsForm extends Component {
  renderFormFields = formField => {
    const { onRemoveField } = this.props;
    if (formField) {
      const dataField = find(flatten(formFields), {
        type: `${formField.type}`
      });
      const { icon, name, fields } = dataField;
      return (
        <Fragment>
          <AppBar position="static">
            {icon()} {name}
            <IconButton
              onClick={() => onRemoveField(formField)}
              // color="primary"
              // component="span"
            >
              <DeleteIcon />
            </IconButton>
          </AppBar>
          {JSON.stringify(fields)} asd
        </Fragment>
      );
    }
    return null;
  };

  render() {
    return <div>{this.renderFormFields(this.props.fieldData)}</div>;
  }
}

export default connect(
  state => ({}),
  {}
)(FieldDetailsForm);
